export const LANDING_PAGE_CAT = 'landingpage';
export const WORK_CAT = 'overview_work';
export const PROCESS_CAT = 'archive';
export const NEWS_CAT = 'news';
export const CV_CAT = 'about';
export const CONTACT_CAT = 'contact';
export const SEL_WORK_CAT = 'selected_work'
